import appStore from 'store';
import api from './api';
import { STATUS_TYPE, PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: 'unaudited',
    detailDialogVisible: false,
    auditDetail: {},
    pagination: PAGINATION,
    totalCount: 0,
    emailType:[]
  },
  getters: {
    auditList: state =>
      state.auditList.slice().map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status]
        };
      }),
    auditDetail: state => ({
      ...state.auditDetail,
      __attachUrl: state.auditDetail.imgUrl
        ? state.auditDetail.imgUrl.split(',')
        : []
    })
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },

    resetAuditList(state) {
      state.auditList = [];
      state.totalCount = 0;
    },

    changeTab(state, payload) {
      state.activeTab = payload;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setAuditDetail(state, payload) {
      state.auditDetail = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, query) { // eslint-disable-line
      commit('changeTab', query.status);
      commit('setPagination', { page: query.page, size: query.size });

      api.getAuditList(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    },
    approve({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.approveAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    detail({ commit }, id) {
      api.getAuditDetail(id).then(({ data }) => {
        console.log(data);
        console.log(data.userObj);
        console.log(data)

        data.userObj.forEach(item=> {
          let res={name:"普通用户"};
          this.emailType.forEach(item2=> {
            if (item2.id===item.groupId){
              res=item2;
            }
          })
            item.gname= res.name;
        })
        console.log(data)
        commit('setAuditDetail', data);
      });
    },

    clearAuditList({commit}) {
      commit('resetAuditList');
    },
    groupInit(){
      api.groupList({
        search: '',
        page: 1,
        size: 100
      }).then(res => {
        console.log(res)
        this.emailType = res.data;
      })
    },
  getGroupOne(){
      return  this.emailType;

  }
  }
};

appStore.registerModule('kycAudit', store);
